import logger from '../../functions/Logger/logger.functions'
import { SnackbarAutoHideDuration } from './Snackbar.types'
import { ShowSnackbarProps, SnackbarContextProps } from './context/Snackbar.context.types'

let snackbarContext: SnackbarContextProps | null = null
// Queue to store snackbars that were requested before context was available
const snackbarQueue: ShowSnackbarProps[] = []

export const setSnackbarContext = (context: SnackbarContextProps) => {
  snackbarContext = context

  // Process any queued snackbars once context is available
  if (snackbarQueue.length > 0) {
    snackbarQueue.forEach((props) => {
      context.show({
        ...props,
        autoHideDuration: props.autoHideDuration || SnackbarAutoHideDuration.MEDIUM
      })
    })

    // Clear the queue after processing
    snackbarQueue.length = 0
  }
}

export const show = (props: ShowSnackbarProps) => {
  if (snackbarContext) {
    snackbarContext.show({
      ...props,
      autoHideDuration: props.autoHideDuration || SnackbarAutoHideDuration.MEDIUM
    })
  } else {
    // Instead of just logging an error, add to queue to show later when context is available
    snackbarQueue.push(props)

    logger.logError('Snackbar context is not set', 'showSnackbar', 'Snackbar', {
      message: props.message,
      severity: props.severity
    })
  }
}

const Snackbar = {
  show
}

export default Snackbar
